export default __webpack_public_path__ + "static/media/telus_health.png";